import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import Header from './../../Layout/Header';
import FooterPremium from './../../Layout/FooterPremium';
import PageTitle from './../../Layout/PageTitle';
// Images
import TowerC from './../../../images/banner/TowerC.jpg';
import bannerImg1 from './../../../images/banner/img1.jpg';
import bannerImg2 from './../../../images/banner/img.png';
import bannerImg3 from './../../../images/banner/ban2.jpeg';
import main1 from './../../../images/gallery/main1.jpg';
import main2 from './../../../images/gallery/main2.jpg';
import main3 from './../../../images/gallery/main3.jpg';
import main4 from './../../../images/gallery/main4.jpg';
import main5 from './../../../images/gallery/main5.jpg';
import main6 from './../../../images/gallery/main6.jpg';
import pic1 from './../../../images/gallery/pic1.jpg';
import pic2 from './../../../images/gallery/pic2.jpg';
import pic3 from './../../../images/gallery/pic3.jpg';
import pic4 from './../../../images/gallery/pic4.jpg';
import mainSlider1 from './../../../images/main-slider/1.jpeg';
import mainSlider2 from './../../../images/main-slider/2.jpeg';
import mainSlider9 from './../../../images/main-slider/9.jpeg';
import mainSlider12 from './../../../images/main-slider/12.jpeg';
import amenity1 from './../../../images/amenities/bg/pic1.jpg';
/* Floor plan section — Goldcrest Dreams Tower C (images/Images/Shot_*.0000.png) */
import fpPlanTypeD from './../../../images/Images/Shot_34.0000.png';
import fpPlanTypeE from './../../../images/Images/Shot_2.0000.png';
import fpPlanTypeA from './../../../images/Images/Shot_16.0000.png';
import fpPlanTypeB from './../../../images/Images/Shot_31.0000.png';
import fpPlanTypeC from './../../../images/Images/Shot_25.0000.png';
import planTypeC2d from './../../../images/1 BHK Type C-20260327T103122Z-1-001/1 BHK Type C/1 BHK B - 909.85.png';
import planTypeC3d from './../../../images/1 BHK Type C-20260327T103122Z-1-001/1 BHK Type C/1 BHK B 3D - 909.85.png';
import planTypeD2d from './../../../images/1BHK S Type D-20260327T103130Z-1-001/1BHK S Type D/1 BHK S (WS).png';
import planTypeD3d from './../../../images/1BHK S Type D-20260327T103130Z-1-001/1BHK S Type D/Type D.PNG';
import planTypeE2d from './../../../images/1BHK Type E-20260327T103133Z-1-001/1BHK Type E/1BHK B (WS).png';
import planTypeE3d from './../../../images/1BHK Type E-20260327T103133Z-1-001/1BHK Type E/1BHK B (WS) 3D.png';
import planTypeB2d from './../../../images/1BHK S Type B-20260327T103126Z-1-001/1BHK S Type B/1BHK S.png';
import planTypeB3d from './../../../images/1BHK S Type B-20260327T103126Z-1-001/1BHK S Type B/1BHK S 856,93.jpeg';
import planTypeA2d from './../../../images/2BHK-20260327T103135Z-1-001/2BHK/2 BHK.png';
import planTypeA3d from './../../../images/2BHK-20260327T103135Z-1-001/2BHK/2 BHK - 1234.25 -3D.png';
import paymentplanImg from './../../../images/about/paymentplan.avif';
import worldclassamenitiesImg from './../../../images/about/worldclassamenities.jpg';
import primelocationImg from './../../../images/about/primelocation.avif';
import goldenvisaImg from './../../../images/about/goldenvisa.avif';
import gymImg from './../../../images/about/gym.jpg';
import loungeImg from './../../../images/about/lounge.jpg';
import milestonePoster from './../../../images/IMG-20260729-WA0000.jpg.jpeg';
import milestoneBg from './../../../images/bg.png';
import PlanSelect from '../../Element/PlanSelect';
import '../FloorPlans.css';
import { sendContactEmail } from '../../../api/emailsender/EmailSender';
import { serializeForm } from '../../../api/emailsender/formSerialize';
/* Explore Interiors gallery — images/Images (Goldcrest Dreams Tower C renders) */
import rgBed8 from './../../../images/Images/Shot_8.0000.png';
import rgBed9 from './../../../images/Images/Shot_9.0000.png';
import rgBed17 from './../../../images/Images/Shot_17.0000.png';
import rgBed20 from './../../../images/Images/Shot_20.0000.png';
import rgBed21 from './../../../images/Images/Shot_21.0000.png';
import rgBed28 from './../../../images/Images/Shot_28.0000.png';
import rgKit1 from './../../../images/Images/Shot_1.0000.png';
import rgKit13 from './../../../images/Images/Shot_13.0000.png';
import rgLiv3 from './../../../images/Images/Shot_3.0000.png';
import rgLiv4 from './../../../images/Images/Shot_4.0000.png';
import rgLiv10 from './../../../images/Images/Shot_10.0000.png';
import rgLiv14 from './../../../images/Images/Shot_14.0000.png';
import rgLiv15 from './../../../images/Images/Shot_15.0000.png';
import rgLiv19 from './../../../images/Images/Shot_19.0000.png';
import rgLiv27 from './../../../images/Images/Shot_27.0000.png';
import rgLiv29 from './../../../images/Images/Shot_29.0000.png';
import rgLiv35 from './../../../images/Images/Shot_35.0000.png';
import rgBath5 from './../../../images/Images/Shot_5.0000.png';
import rgBath6 from './../../../images/Images/Shot_6.0000.png';
import rgBath7 from './../../../images/Images/Shot_7.0000.png';
import rgBath11 from './../../../images/Images/Shot_11.0000.png';
import rgBath12 from './../../../images/Images/Shot_12.0000.png';
import rgBath22 from './../../../images/Images/Shot_22.0000.png';
import rgBath23 from './../../../images/Images/Shot_23.0000.png';
import rgBath26 from './../../../images/Images/Shot_26.00001.png';
import rgBath30 from './../../../images/Images/Shot_30.0000.png';
import rgBath32 from './../../../images/Images/Shot_32.0000.png';
import rgBath33 from './../../../images/Images/Shot_33.0000.png';

// Apartment plan data with pricing
const APARTMENT_PLANS = [
	{
		name: '1 BHK+STUDY PLAN TYPE D',
		sqft: '1012.13 SQ. FT',
		features: ['1 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Study Room', 'Store', 'Hall', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 556,671.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 5,566.72',
		downPayment: '40% DOWN PAYMENT',
	},
	{
		name: '1 BHK+STUDY PLAN TYPE E',
		sqft: '1195.35 SQ. FT',
		features: ['1 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Study Room', 'Store', 'Hall', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 657,442.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 6,574.43',
		downPayment: '40% DOWN PAYMENT',
	},
	{
		name: '2 BHK PLAN TYPE A',
		sqft: '1234.25 SQ. FT',
		features: ['2 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Spacious Hall', 'Store', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 678,837.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 6,788.38',
		downPayment: '40% DOWN PAYMENT',
	},
	{
		name: '1 BHK PLAN TYPE B',
		sqft: '856.93 SQ. FT',
		features: ['1 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Hall', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 471,311.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 4,713.11',
		downPayment: '40% DOWN PAYMENT',
	},
	{
		name: '1 BHK PLAN TYPE C',
		sqft: '909.85 SQ. FT',
		features: ['1 Bedroom', '1 Bathroom', '1 Guest Washroom', 'Hall', 'Store', '1 Balcony', 'Kitchen'],
		totalPrice: 'AED 500,417.50',
		pricePerSqft: 'AED 550/SQ FT',
		monthlyPayment: 'AED 5,004.18',
		downPayment: '40% DOWN PAYMENT',
	},
];

// Explore Interiors — images/Images by room (Shot_*); overlaps reuse floor-plan imports where same file
/** Floor plan diagrams for lightbox (Type C: 2D + 3D from project folder) */
const FLOOR_PLAN_POPUP_GALLERY = {
	'1 BHK+STUDY PLAN TYPE D': [
		{ src: planTypeD2d, caption: '2D floor plan' },
		{ src: planTypeD3d, caption: '3D floor plan' },
	],
	'1 BHK+STUDY PLAN TYPE E': [
		{ src: planTypeE2d, caption: '2D floor plan' },
		{ src: planTypeE3d, caption: '3D floor plan' },
	],
	'2 BHK PLAN TYPE A': [
		{ src: planTypeA2d, caption: '2D floor plan' },
		{ src: planTypeA3d, caption: '3D floor plan' },
	],
	'1 BHK PLAN TYPE B': [
		{ src: planTypeB2d, caption: '2D floor plan' },
		{ src: planTypeB3d, caption: '3D floor plan' },
	],
	'1 BHK PLAN TYPE C': [
		{ src: planTypeC2d, caption: '2D floor plan' },
		{ src: planTypeC3d, caption: '3D floor plan' },
	],
};

const ROOM_GALLERY = {
	bedroom: [rgBed8, rgBed9, rgBed17, rgBed20, rgBed21, rgBed28, fpPlanTypeD],
	kitchen: [rgKit1, rgKit13, fpPlanTypeC],
	living: [fpPlanTypeE, rgLiv3, rgLiv4, rgLiv10, rgLiv14, rgLiv15, fpPlanTypeA, rgLiv19, rgLiv27, rgLiv29, rgLiv35],
	bathroom: [rgBath5, rgBath6, rgBath7, rgBath11, rgBath12, rgBath22, rgBath23, rgBath26, rgBath30, fpPlanTypeB, rgBath32, rgBath33],
};

/** Try Floor Plans: alternating living → bedroom side images (distinct from each other) */
const TRY_FLOOR_PLAN_DEFAULT_SIDE_IMAGE = {
	'1 BHK+STUDY PLAN TYPE D': rgLiv3,
	'1 BHK+STUDY PLAN TYPE E': rgBed8,
	'2 BHK PLAN TYPE A': rgLiv10,
	'1 BHK PLAN TYPE B': rgBed9,
	'1 BHK PLAN TYPE C': rgLiv14,
};

const LOCATION_AMENITIES = [
	{ icon: 'las la-shopping-bag', title: '15 MINUTES TO AJMAN CITY CENTER' },
	{ icon: 'las la-graduation-cap', title: '15 MINUTES TO SHARJAH UNIVERSITY' },
	{ icon: 'las la-plane', title: '25 MINUTES TO DUBAI AIRPORT' },
	{ icon: 'las la-umbrella-beach', title: '22 MINUTES TO AL MAJRAJAN ISLAND' },
	{ icon: 'las la-city', title: '45 MINUTES TO DUBAI MALL / BURJ KHALIFA / DOWNTOWN' },
	{ icon: 'las la-industry', title: '15 MINUTES TO SHARJAH INDUSTRIAL AREA' },
	{ icon: 'las la-water', title: '12 MINUTES TO AJMAN OPEN BEACH' },
	{ icon: 'las la-university', title: '12 MINUTES TO AJMAN EDUCATION INSTITUTION' },
];

const LIFESTYLE_FACILITIES = [
	{
		title: '5 YEARS FLEXIBLE PAYMENT PLAN',
		image: paymentplanImg,
		desc: 'INCLUDES 30 MONTHS DURING CONSTRUCTION & 30 MONTHS POST HANDOVER',
	},
	{
		title: 'WORLD CLASS AMENITIES',
		image: worldclassamenitiesImg,
		desc: 'KIDS PLAY AREA, SWIMMING POOL & GYM FOR LADIES & GENTS',
	},
	{
		title: 'PRIME LOCATION',
		image: primelocationImg,
		desc: 'DIRECT ACCESS TO COMMUNITY PARK, MALL, SUPER MART & MEDICAL CENTRE',
	},
	{
		title: 'GOLDEN VISA ELIGIBILITY',
		image: goldenvisaImg,
		desc: 'WHILE INVESTING AED 2 MILLION',
	},
];

const PROJECT_FEATURES = [
	{ title: '5 YEARS FLEXIBLE PAYMENT PLAN', desc: 'INCLUDES 30 MONTHS DURING CONSTRUCTION & 30 MONTHS POST HANDOVER' },
	{ title: 'WORLD CLASS AMENITIES', desc: 'KIDS PLAY AREA, SWIMMING POOL & GYM FOR LADIES & GENTS' },
	{ title: 'PRIME LOCATION', desc: 'DIRECT ACCESS TO COMMUNITY PARK, MALL, SUPER MART & MEDICAL CENTRE' },
	{ title: 'GOLDEN VISA ELIGIBILITY', desc: 'WHILE INVESTING AED 2 MILLION' },
];

const INVESTMENT_BENEFITS = [
	'100% FREE HOLD PROPERTY',
	'ZERO% TAX ON INCOME FROM PROPERTY',
	'MORE THAN 8% RETURN ON INVESTMENT',
	'GOLDEN VISA ELIGIBILITY WHILE INVESTING AED 2',
];

class GoldcrestDreamTowerC extends Component {
	state = {
		activeRoom: 'living',
		showCustomizedModal: false,
		selectedPlan: '',
		customizedPlanSubmitting: false,
		customizedPlanError: '',
		floorPlanPopupPlan: null,
		floorPlanSlideIndex: 0,
		// Hover swapping for floor-plan card side images (Bedroom/Bathroom/etc)
		floorPlanHoverInteriorByPlan: {},
		tryFloorPlanHoverInteriorByPlan: {},
	};
	scrollObserver = null;

	componentDidMount() {
		this.scrollObserver = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('tower-c-visible');
					}
				});
			},
			{ rootMargin: '0px 0px -60px 0px', threshold: 0.05 }
		);
		setTimeout(() => {
			document.querySelectorAll('.tower-c-animate').forEach((el) => this.scrollObserver.observe(el));
		}, 150);
	}

	componentDidUpdate(prevProps, prevState) {
		const modalOpen = this.state.showCustomizedModal || this.state.floorPlanPopupPlan;
		const prevModalOpen = prevState.showCustomizedModal || prevState.floorPlanPopupPlan;
		if (modalOpen !== prevModalOpen) {
			document.body.style.overflow = modalOpen ? 'hidden' : '';
		}
	}

	handleCustomizedPlanSubmit = async (e) => {
		e.preventDefault();
		const form = e.currentTarget;
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		this.setState({ customizedPlanSubmitting: true, customizedPlanError: '' });
		const formData = serializeForm(form);
		formData.formSource = 'Goldcrest Dreams Tower C';
		const result = await sendContactEmail(formData, 'Star Giga — Customized plan request (Goldcrest Dreams Tower C)');
		this.setState({ customizedPlanSubmitting: false });
		if (result.ok) {
			form.reset();
			this.setState({ showCustomizedModal: false });
			alert('Thank you! We will contact you shortly with your customized plan.');
		} else {
			this.setState({ customizedPlanError: result.error });
			alert(result.error);
		}
	};

	openFloorPlanPopup = (plan) => {
		this.setState({ floorPlanPopupPlan: plan, floorPlanSlideIndex: 0 });
	};

	closeFloorPlanPopup = () => {
		this.setState({ floorPlanPopupPlan: null });
	};

	floorPlanSliderPrev = () => {
		const plan = this.state.floorPlanPopupPlan;
		if (!plan) return;
		const gallery = FLOOR_PLAN_POPUP_GALLERY[plan];
		if (!gallery?.length) return;
		this.setState((s) => ({
			floorPlanSlideIndex: (s.floorPlanSlideIndex - 1 + gallery.length) % gallery.length,
		}));
	};

	floorPlanSliderNext = () => {
		const plan = this.state.floorPlanPopupPlan;
		if (!plan) return;
		const gallery = FLOOR_PLAN_POPUP_GALLERY[plan];
		if (!gallery?.length) return;
		this.setState((s) => ({
			floorPlanSlideIndex: (s.floorPlanSlideIndex + 1) % gallery.length,
		}));
	};

	getFloorPlanInteriorKeyFromText = (text) => {
		const t = (text || '').toLowerCase();
		if (t.includes('bedroom') || t.includes('study')) return 'bedroom';
		if (t.includes('bathroom') || t.includes('washroom')) return 'bathroom';
		if (t.includes('kitchen')) return 'kitchen';
		if (t.includes('hall') || t.includes('living') || t.includes('balcony')) return 'living';
		return 'bedroom';
	};

	getFloorPlanInteriorImageSrc = (interiorKey) => {
		switch (interiorKey) {
			case 'bathroom':
				return rgBath5;
			case 'kitchen':
				return rgKit1;
			case 'living':
				// "Hall" uses living/dining curved image
				return fpPlanTypeE;
			case 'bedroom':
			default:
				return fpPlanTypeD;
		}
	};

	getFloorPlanSideImageSrc = (planName) => {
		const hoverKey =
			(this.state.floorPlanHoverInteriorByPlan && this.state.floorPlanHoverInteriorByPlan[planName]) || 'bedroom';
		return this.getFloorPlanInteriorImageSrc(hoverKey);
	};

	getTryFloorPlanSideImageSrc = (planName) => {
		const hoverKey = this.state.tryFloorPlanHoverInteriorByPlan && this.state.tryFloorPlanHoverInteriorByPlan[planName];
		if (hoverKey) return this.getFloorPlanInteriorImageSrc(hoverKey);
		return TRY_FLOOR_PLAN_DEFAULT_SIDE_IMAGE[planName] || fpPlanTypeD;
	};

	handleFloorPlanFeaturesEnter = (planName, e) => {
		const rawTarget = e && e.target;
		const target = rawTarget && rawTarget.nodeType === 3 ? rawTarget.parentElement : rawTarget;
		const li = target && target.closest ? target.closest('li') : null;
		if (!li) return;
		const interiorKey = this.getFloorPlanInteriorKeyFromText(li.textContent || '');
		this.setState((s) => {
			const prev = (s.floorPlanHoverInteriorByPlan && s.floorPlanHoverInteriorByPlan[planName]) || 'bedroom';
			if (prev === interiorKey) return null;
			return {
				floorPlanHoverInteriorByPlan: {
					...(s.floorPlanHoverInteriorByPlan || {}),
					[planName]: interiorKey,
				},
			};
		});
	};

	handleFloorPlanFeaturesLeave = (planName) => {
		this.setState((s) => ({
			floorPlanHoverInteriorByPlan: {
				...(s.floorPlanHoverInteriorByPlan || {}),
				[planName]: 'bedroom',
			},
		}));
	};

	handleTryFloorPlanFeaturesEnter = (planName, e) => {
		const rawTarget = e && e.target;
		const target = rawTarget && rawTarget.nodeType === 3 ? rawTarget.parentElement : rawTarget;
		const li = target && target.closest ? target.closest('li') : null;
		if (!li) return;
		const interiorKey = this.getFloorPlanInteriorKeyFromText(li.textContent || '');
		this.setState((s) => {
			const prev = (s.tryFloorPlanHoverInteriorByPlan && s.tryFloorPlanHoverInteriorByPlan[planName]) || null;
			if (prev === interiorKey) return null;
			return {
				tryFloorPlanHoverInteriorByPlan: {
					...(s.tryFloorPlanHoverInteriorByPlan || {}),
					[planName]: interiorKey,
				},
			};
		});
	};

	handleTryFloorPlanFeaturesLeave = (planName) => {
		this.setState((s) => {
			const next = { ...(s.tryFloorPlanHoverInteriorByPlan || {}) };
			delete next[planName];
			return { tryFloorPlanHoverInteriorByPlan: next };
		});
	};

	componentWillUnmount() {
		if (this.scrollObserver) this.scrollObserver.disconnect();
		document.body.style.overflow = '';
	}

	render() {
		const { activeRoom } = this.state;
		const galleryImages = (ROOM_GALLERY[activeRoom] || ROOM_GALLERY.living).slice(0, 8);
		const floorPlanSideImgD = this.getFloorPlanSideImageSrc('1 BHK+STUDY PLAN TYPE D');
		const floorPlanSideImgE = this.getFloorPlanSideImageSrc('1 BHK+STUDY PLAN TYPE E');
		const floorPlanSideImgA = this.getFloorPlanSideImageSrc('2 BHK PLAN TYPE A');
		const floorPlanSideImgB = this.getFloorPlanSideImageSrc('1 BHK PLAN TYPE B');
		const floorPlanSideImgC = this.getFloorPlanSideImageSrc('1 BHK PLAN TYPE C');
		const tryFloorPlanSideImgD = this.getTryFloorPlanSideImageSrc('1 BHK+STUDY PLAN TYPE D');
		const tryFloorPlanSideImgE = this.getTryFloorPlanSideImageSrc('1 BHK+STUDY PLAN TYPE E');
		const tryFloorPlanSideImgA = this.getTryFloorPlanSideImageSrc('2 BHK PLAN TYPE A');
		const tryFloorPlanSideImgB = this.getTryFloorPlanSideImageSrc('1 BHK PLAN TYPE B');
		const tryFloorPlanSideImgC = this.getTryFloorPlanSideImageSrc('1 BHK PLAN TYPE C');

		return (
			<Fragment>
				<Header />
				<div className="page-content tower-c-premium">
					<PageTitle motherMenu="Projects" activeMenu="Goldcrest Dreams Tower C" />

					{/* Hero Section - Where Ambition Has No Limits */}
					{/* <section className="tower-c-hero">
						<div className="tower-c-hero-bg" style={{ backgroundImage: `url(${TowerC})` }} />
						<div className="tower-c-hero-overlay" />
						<div className="container">
							<div className="row align-items-center min-vh-75">
								<div className="col-lg-6">
									<h1 className="tower-c-hero-title">WHERE AMBITION HAS NO LIMITS</h1>
									<p className="tower-c-hero-desc">
										Now, you can experience it all in one extraordinary location. Live in the heart of Ajman, surrounded by the vibrant pulse of the city while enjoying a luxurious lifestyle with premium amenities at your fingertips. With everything you need just steps away, from fine dining to exclusive shopping, you're perfectly positioned to enjoy the city's top attractions, whether you're seeking excitement or tranquility, day or night.
									</p>
									<Link to="/contact-us" className="tower-c-glass-btn tower-c-glass-btn-primary">
										REQUEST A CONSULTATION
									</Link>
								</div>
							</div>
						</div>
					</section> */}

					{/* 1 & 2 Bedroom Apartment Section */}
					<section className="tower-c-apartment-intro">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-lg-6 mb-5 mb-lg-0 tower-c-animate" data-animate="left" style={{ '--tower-delay': '0ms' }}>
									<h2 className="tower-c-section-title-dark">WHERE AMBITION HAS NO LIMITS</h2>
									<p className="tower-c-intro-text">
									Now, you can experience it all in one extraordinary location. Live in the heart of Ajman, surrounded by the vibrant pulse of the city while enjoying a luxurious lifestyle with premium amenities at your fingertips. With everything you need just steps away, from fine dining to exclusive shopping, you're perfectly positioned to enjoy the city's top attractions, whether you're seeking excitement or tranquility, day or night.
									</p>
									<a href="/project-brochure.pdf" download="Project-Brochure.pdf" className="tower-c-brochure-btn">
										<div className="tower-c-brochure-icon">
											<i className="las la-file-pdf" />
										</div>
										<div className="tower-c-brochure-text">
											<span className="tower-c-brochure-title">PROJECT BROCHURE</span>
											<span className="tower-c-brochure-download">DOWNLOAD <i className="las la-arrow-down" /></span>
										</div>
									</a>
									{/* <div className="tower-c-interior-grid">
										<img src={main1} alt="Bedroom" className="tower-c-interior-main" />
										<img src={bannerImg1} alt="Living" className="tower-c-interior-small" />
										<img src={main5} alt="Kitchen" className="tower-c-interior-small" />
										<img src={main3} alt="Bathroom" className="tower-c-interior-small" />
									</div> */}
								</div>
								<div className="col-lg-6 tower-c-animate" data-animate="right" style={{ '--tower-delay': '100ms' }}>
									<div className="tower-c-building-visual" style={{ backgroundImage: `url(${TowerC})` }} />
								</div>
							</div>
						</div>
					</section>

					{/* 1 & 2 Bedroom Apartment - About Style Section */}
					<section className="award-section tower-c-award-section" >
						<div className="container award-container">
							<div className="award-header">
								<h2 className="award-title tower-c-animate" data-animate="up" style={{ '--tower-delay': '0ms' }}>
									<span>1 & 2 BEDROOM APARTMENT</span>
								</h2>
								<div className="award-content tower-c-animate" data-animate="up" style={{ '--tower-delay': '80ms' }}>
									<p>
										Goldcrest Dreams, Ajman has 1 and 2-bedroom Apartments in each of its five stories. There is a balcony in every unit and an open kitchen, tiled baths, and built-in wardrobes in the bedrooms.
									</p>
									<p>
										Glass doors connect the bedrooms and living areas to the balcony. Wood cabinets and stone worktops are used in the kitchen. There's also a sink, a working hood, and enough room for a cooking range.
									</p>
								</div>
							</div>
						</div>
					</section>

					{/* Milestone Achievement — Final Slab Tower C */}
					<section className="tower-c-milestone">
						<div
							className="tower-c-milestone__bg"
							style={{ backgroundImage: `url(${milestoneBg})` }}
							aria-hidden="true"
						/>
						<div className="tower-c-milestone__wash" aria-hidden="true" />
						<div className="container tower-c-milestone__inner">
							<div className="row align-items-center tower-c-milestone__row">
								<div className="col-lg-6 mb-4 mb-lg-0 tower-c-animate" data-animate="left" style={{ '--tower-delay': '0ms' }}>
									<div className="tower-c-milestone__visual">
										<img
											src={milestonePoster}
											alt="Hurrah! A Milestone Achievement — Final Slab Completed, Goldcrest Dreams Tower C"
										/>
									</div>
								</div>
								<div className="col-lg-6 tower-c-animate" data-animate="right" style={{ '--tower-delay': '100ms' }}>
									<div className="tower-c-milestone__copy">
										<span className="tower-c-milestone__eyebrow">Latest Milestone</span>
										<h2 className="tower-c-section-title-dark tower-c-milestone__title">
											A Milestone Achievement
										</h2>
										<div className="tower-c-milestone__rule" aria-hidden="true" />
										<p className="tower-c-intro-text tower-c-milestone__text">
											The final slab of Tower C is complete — another step forward in delivering
											Goldcrest Dreams with the same care for quality, timing, and trust that
											defines every Star Giga project.
										</p>
										<div className="tower-c-milestone__badge">
											<span className="tower-c-milestone__badge-check" aria-hidden="true">✓</span>
											<span>Final Slab Completed — <strong>Tower C</strong></span>
										</div>
										<p className="tower-c-milestone__thanks">
											Thank you to our team, partners, and valued clients for sharing this journey.
										</p>
										<span className="tower-c-milestone__brand">Goldcrest by Star Giga</span>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* Milestone Achievement End */}

					{/* Facilities For Lifestyle */}
					<section className="tower-c-facilities">
						<div className="container">
							<div className="tower-c-facilities-header tower-c-animate" data-animate="up" style={{ '--tower-delay': '0ms' }}>
								<div className="tower-c-facilities-heading">
									<span className="tower-c-facilities-label">OWN A PLACE WHERE LIFE'S A DREAM, AND YOU'RE LIVING IT</span>
									<h2 className="tower-c-facilities-title">PROJECT HIGHLIGHTS</h2>
								</div>
								{/* <Link to="/contact-us" className="tower-c-facilities-viewmore">
									customized Plan
								</Link> */}
							</div>
							<div className="tower-c-facilities-grid">
								{LIFESTYLE_FACILITIES.map((item, i) => (
									<div className="tower-c-facility-card tower-c-animate" key={i} data-animate="up" style={{ '--tower-delay': `${i * 80}ms` }}>
										<div className="tower-c-facility-image">
											<img src={item.image} alt={item.title} />
										</div>
										<div className="tower-c-facility-content">
											<h4 className="tower-c-facility-title">{item.title}</h4>
											<p className="tower-c-facility-desc">{item.desc}</p>
										</div>
									</div>
								))}
							</div>
						</div>
					</section>

					{/* Floor Plans - Image + Content */}
				

					<section id="try-floor-plans" className="tower-c-floor-plans tower-c-try-floor-plans">
						<div className="container">
							<div className="tower-c-section-head text-center tower-c-animate" data-animate="up" style={{ '--tower-delay': '0ms' }}>
								<h2 className="tower-c-section-title"> Floor Plans</h2>
								<p className="tower-c-section-subtitle">Explore our thoughtfully designed layouts</p>
								<div className="tower-c-section-line" />
							</div>
							{/* 1 Bedroom Floor Plan - 1 BHK+STUDY PLAN TYPE D */}
							<div className="tower-c-floor-plan-row tower-c-floor-plan-equal-height" data-try-plan="type-d">
								<div className="row align-items-stretch mb-5 mb-lg-0">
									<div className="col-lg-4 order-lg-1 mb-4 mb-lg-0 tower-c-animate" data-animate="left" style={{ '--tower-delay': '0ms' }}>
										<div className="tower-c-floor-plan-content tower-c-floor-plan-content-equal">
											<h3 className="tower-c-plan-name">1 BHK+STUDY PLAN TYPE D</h3>
											<p className="tower-c-plan-sqft">1012.13 SQ. FT</p>
											<button
												type="button"
												className="tower-c-floor-plan-see-link"
												onClick={() => this.openFloorPlanPopup('1 BHK+STUDY PLAN TYPE D')}
											>
												See floor plan images
											</button>
											<div
												className="tower-c-floor-plan-features-grid"
												onMouseMove={(e) => this.handleTryFloorPlanFeaturesEnter('1 BHK+STUDY PLAN TYPE D', e)}
												onMouseLeave={() => this.handleTryFloorPlanFeaturesLeave('1 BHK+STUDY PLAN TYPE D')}
											>
												<ul className="tower-c-plan-features">
													<li>1 Bedroom</li>
													<li>1 Bathroom</li>
													<li>1 Guest Washroom</li>
													<li>Study Room</li>
												</ul>
												<ul className="tower-c-plan-features">
													<li>Store</li>
													<li>Hall</li>
													<li>1 Balcony</li>
													<li>Kitchen</li>
												</ul>
											</div>
											<div className="tower-c-plan-pricing">
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Total Price</span>
													<span className="tower-c-plan-value">AED 556,671.50</span>
												</div>
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Per SQ FT</span>
													<span className="tower-c-plan-value">AED 550/SQ FT</span>
												</div>
												<div className="tower-c-plan-monthly">
													<span className="tower-c-plan-monthly-label">Monthly Payment</span>
													<span className="tower-c-plan-monthly-value">AED 5,566.72 /MONTH</span>
													<p className="tower-c-plan-down tower-c-plan-down--in-monthly">40% DOWN PAYMENT</p>
												</div>
											</div>
											<div className="tower-c-try-plan-cta">
												<button
													type="button"
													className="tower-c-try-plan-btn"
													onClick={() =>
														this.setState({
															showCustomizedModal: true,
															selectedPlan: '1 BHK+STUDY PLAN TYPE D',
														})
													}
												>
													Interested in having your own plan
												</button>
											</div>
										</div>
									</div>
									<div className="col-lg-8 order-lg-2 tower-c-animate" data-animate="right" style={{ '--tower-delay': '100ms' }}>
										<div className="tower-c-floor-plan-image tower-c-floor-plan-image-equal tower-c-floor-plan-image--slant-right">
											<img
												src={tryFloorPlanSideImgD}
												key={tryFloorPlanSideImgD}
												alt="1 BHK+STUDY PLAN TYPE D"
												className="tower-c-floor-plan-swap-img"
											/>
										</div>
									</div>
								</div>
							</div>
							{/* 2 Bedroom Floor Plan - 1 BHK+STUDY PLAN TYPE E */}
							<div className="tower-c-floor-plan-row tower-c-floor-plan-equal-height" data-try-plan="type-e">
								<div className="row align-items-stretch mb-5 mb-lg-0">
									<div className="col-lg-8 order-lg-1 mb-4 mb-lg-0 tower-c-animate" data-animate="left" style={{ '--tower-delay': '0ms' }}>
										<div className="tower-c-floor-plan-image tower-c-floor-plan-image-equal tower-c-floor-plan-image--slant-left">
											<img
												src={tryFloorPlanSideImgE}
												key={tryFloorPlanSideImgE}
												alt="1 BHK+STUDY PLAN TYPE E"
												className="tower-c-floor-plan-swap-img"
											/>
										</div>
									</div>
									<div className="col-lg-4 order-lg-2 tower-c-animate" data-animate="right" style={{ '--tower-delay': '100ms' }}>
										<div className="tower-c-floor-plan-content tower-c-floor-plan-content-equal">
											<h3 className="tower-c-plan-name">1 BHK+STUDY PLAN TYPE E</h3>
											<p className="tower-c-plan-sqft">1195.35 SQ. FT</p>
											<button
												type="button"
												className="tower-c-floor-plan-see-link"
												onClick={() => this.openFloorPlanPopup('1 BHK+STUDY PLAN TYPE E')}
											>
												See floor plan images
											</button>
											<div
												className="tower-c-floor-plan-features-grid"
												onMouseMove={(e) => this.handleTryFloorPlanFeaturesEnter('1 BHK+STUDY PLAN TYPE E', e)}
												onMouseLeave={() => this.handleTryFloorPlanFeaturesLeave('1 BHK+STUDY PLAN TYPE E')}
											>
												<ul className="tower-c-plan-features">
													<li>1 Bedroom</li>
													<li>1 Bathroom</li>
													<li>1 Guest Washroom</li>
													<li>Study Room</li>
												</ul>
												<ul className="tower-c-plan-features">
													<li>Store</li>
													<li>Hall</li>
													<li>1 Balcony</li>
													<li>Kitchen</li>
												</ul>
											</div>
											<div className="tower-c-plan-pricing">
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Total Price</span>
													<span className="tower-c-plan-value">AED 657,442.50</span>
												</div>
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Per SQ FT</span>
													<span className="tower-c-plan-value">AED 550/SQ FT</span>
												</div>
												<div className="tower-c-plan-monthly">
													<span className="tower-c-plan-monthly-label">Monthly Payment</span>
													<span className="tower-c-plan-monthly-value">AED 6,574.43 /MONTH</span>
													<p className="tower-c-plan-down tower-c-plan-down--in-monthly">40% DOWN PAYMENT</p>
												</div>
											</div>
											<div className="tower-c-try-plan-cta">
												<button
													type="button"
													className="tower-c-try-plan-btn"
													onClick={() =>
														this.setState({
															showCustomizedModal: true,
															selectedPlan: '1 BHK+STUDY PLAN TYPE E',
														})
													}
												>
													Interested in having your own plan
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
							{/* 2 BHK PLAN TYPE A */}
							<div className="tower-c-floor-plan-row tower-c-floor-plan-equal-height" data-try-plan="type-a">
								<div className="row align-items-stretch mb-5 mb-lg-0">
									<div className="col-lg-4 order-lg-1 mb-4 mb-lg-0 tower-c-animate" data-animate="left" style={{ '--tower-delay': '0ms' }}>
										<div className="tower-c-floor-plan-content tower-c-floor-plan-content-equal">
											<h3 className="tower-c-plan-name">2 BHK PLAN TYPE A</h3>
											<p className="tower-c-plan-sqft">1234.25 SQ. FT</p>
											<button
												type="button"
												className="tower-c-floor-plan-see-link"
												onClick={() => this.openFloorPlanPopup('2 BHK PLAN TYPE A')}
											>
												See floor plan images
											</button>
											<div
												className="tower-c-floor-plan-features-grid"
												onMouseMove={(e) => this.handleTryFloorPlanFeaturesEnter('2 BHK PLAN TYPE A', e)}
												onMouseLeave={() => this.handleTryFloorPlanFeaturesLeave('2 BHK PLAN TYPE A')}
											>
												<ul className="tower-c-plan-features">
													<li>2 Bedroom</li>
													<li>1 Bathroom</li>
													<li>1 Guest Washroom</li>
													<li>Spacious Hall</li>
												</ul>
												<ul className="tower-c-plan-features">
													<li>Store</li>
													<li>1 Balcony</li>
													<li>Kitchen</li>
												</ul>
											</div>
											<div className="tower-c-plan-pricing">
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Total Price</span>
													<span className="tower-c-plan-value">AED 678,837.50</span>
												</div>
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Per SQ FT</span>
													<span className="tower-c-plan-value">AED 550/SQ FT</span>
												</div>
												<div className="tower-c-plan-monthly">
													<span className="tower-c-plan-monthly-label">Monthly Payment</span>
													<span className="tower-c-plan-monthly-value">AED 6,788.38 /MONTH</span>
													<p className="tower-c-plan-down tower-c-plan-down--in-monthly">40% DOWN PAYMENT</p>
												</div>
											</div>
											<div className="tower-c-try-plan-cta">
												<button
													type="button"
													className="tower-c-try-plan-btn"
													onClick={() =>
														this.setState({
															showCustomizedModal: true,
															selectedPlan: '2 BHK PLAN TYPE A',
														})
													}
												>
													Interested in having your own plan
												</button>
											</div>
										</div>
									</div>
									<div className="col-lg-8 order-lg-2 tower-c-animate" data-animate="right" style={{ '--tower-delay': '100ms' }}>
										<div className="tower-c-floor-plan-image tower-c-floor-plan-image-equal tower-c-floor-plan-image--slant-right">
											<img
												src={tryFloorPlanSideImgA}
												key={tryFloorPlanSideImgA}
												alt="2 BHK PLAN TYPE A"
												className="tower-c-floor-plan-swap-img"
											/>
										</div>
									</div>
								</div>
							</div>
							{/* 1 BHK PLAN TYPE B */}
							<div className="tower-c-floor-plan-row tower-c-floor-plan-equal-height" data-try-plan="type-b">
								<div className="row align-items-stretch mb-5 mb-lg-0">
									<div className="col-lg-8 order-lg-1 mb-4 mb-lg-0 tower-c-animate" data-animate="left" style={{ '--tower-delay': '0ms' }}>
										<div className="tower-c-floor-plan-image tower-c-floor-plan-image-equal tower-c-floor-plan-image--slant-left">
											<img
												src={tryFloorPlanSideImgB}
												key={tryFloorPlanSideImgB}
												alt="1 BHK PLAN TYPE B"
												className="tower-c-floor-plan-swap-img"
											/>
										</div>
									</div>
									<div className="col-lg-4 order-lg-2 tower-c-animate" data-animate="right" style={{ '--tower-delay': '100ms' }}>
										<div className="tower-c-floor-plan-content tower-c-floor-plan-content-equal">
											<h3 className="tower-c-plan-name">1 BHK PLAN TYPE B</h3>
											<p className="tower-c-plan-sqft">856.93 SQ. FT</p>
											<button
												type="button"
												className="tower-c-floor-plan-see-link"
												onClick={() => this.openFloorPlanPopup('1 BHK PLAN TYPE B')}
											>
												See floor plan images
											</button>
											<div
												className="tower-c-floor-plan-features-grid"
												onMouseMove={(e) => this.handleTryFloorPlanFeaturesEnter('1 BHK PLAN TYPE B', e)}
												onMouseLeave={() => this.handleTryFloorPlanFeaturesLeave('1 BHK PLAN TYPE B')}
											>
												<ul className="tower-c-plan-features">
													<li>1 Bedroom</li>
													<li>1 Bathroom</li>
													<li>1 Guest Washroom</li>
												</ul>
												<ul className="tower-c-plan-features">
													<li>Hall</li>
													<li>1 Balcony</li>
													<li>Kitchen</li>
												</ul>
											</div>
											<div className="tower-c-plan-pricing">
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Total Price</span>
													<span className="tower-c-plan-value">AED 471,311.50</span>
												</div>
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Per SQ FT</span>
													<span className="tower-c-plan-value">AED 550/SQ FT</span>
												</div>
												<div className="tower-c-plan-monthly">
													<span className="tower-c-plan-monthly-label">Monthly Payment</span>
													<span className="tower-c-plan-monthly-value">AED 4,713.11 /MONTH</span>
													<p className="tower-c-plan-down tower-c-plan-down--in-monthly">40% DOWN PAYMENT</p>
												</div>
											</div>
											<div className="tower-c-try-plan-cta">
												<button
													type="button"
													className="tower-c-try-plan-btn"
													onClick={() =>
														this.setState({
															showCustomizedModal: true,
															selectedPlan: '1 BHK PLAN TYPE B',
														})
													}
												>
													Interested in having your own plan
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
							{/* 1 BHK PLAN TYPE C */}
							<div className="tower-c-floor-plan-row tower-c-floor-plan-equal-height" data-try-plan="type-c">
								<div className="row align-items-stretch mb-5 mb-lg-0">
									<div className="col-lg-4 order-lg-1 mb-4 mb-lg-0 tower-c-animate" data-animate="left" style={{ '--tower-delay': '0ms' }}>
										<div className="tower-c-floor-plan-content tower-c-floor-plan-content-equal">
											<h3 className="tower-c-plan-name">1 BHK PLAN TYPE C</h3>
											<p className="tower-c-plan-sqft">909.85 SQ. FT</p>
											<button
												type="button"
												className="tower-c-floor-plan-see-link"
												onClick={() => this.openFloorPlanPopup('1 BHK PLAN TYPE C')}
											>
												See floor plan images
											</button>
											<div
												className="tower-c-floor-plan-features-grid"
												onMouseMove={(e) => this.handleTryFloorPlanFeaturesEnter('1 BHK PLAN TYPE C', e)}
												onMouseLeave={() => this.handleTryFloorPlanFeaturesLeave('1 BHK PLAN TYPE C')}
											>
												<ul className="tower-c-plan-features">
													<li>1 Bedroom</li>
													<li>1 Bathroom</li>
													<li>1 Guest Washroom</li>
													<li>Hall</li>
												</ul>
												<ul className="tower-c-plan-features">
													<li>Store</li>
													<li>1 Balcony</li>
													<li>Kitchen</li>
												</ul>
											</div>
											<div className="tower-c-plan-pricing">
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Total Price</span>
													<span className="tower-c-plan-value">AED 500,417.50</span>
												</div>
												<div className="tower-c-plan-price-row">
													<span className="tower-c-plan-label">Per SQ FT</span>
													<span className="tower-c-plan-value">AED 550/SQ FT</span>
												</div>
												<div className="tower-c-plan-monthly">
													<span className="tower-c-plan-monthly-label">Monthly Payment</span>
													<span className="tower-c-plan-monthly-value">AED 5,004.18 /MONTH</span>
													<p className="tower-c-plan-down tower-c-plan-down--in-monthly">40% DOWN PAYMENT</p>
												</div>
											</div>
											<div className="tower-c-try-plan-cta">
												<button
													type="button"
													className="tower-c-try-plan-btn"
													onClick={() =>
														this.setState({
															showCustomizedModal: true,
															selectedPlan: '1 BHK PLAN TYPE C',
														})
													}
												>
													Interested in having your own plan
												</button>
											</div>
										</div>
									</div>
									<div className="col-lg-8 order-lg-2 tower-c-animate" data-animate="right" style={{ '--tower-delay': '100ms' }}>
										<div className="tower-c-floor-plan-image tower-c-floor-plan-image-equal tower-c-floor-plan-image--slant-right">
											<img
												src={tryFloorPlanSideImgC}
												key={tryFloorPlanSideImgC}
												alt="1 BHK PLAN TYPE C"
												className="tower-c-floor-plan-swap-img"
											/>
										</div>
									</div>
								</div>
							</div>

						</div>
					</section>

					{/* Feature Cards - Glass Style */}
					{/* <section className="tower-c-features">
						<div className="container">
							<div className="row">
								{PROJECT_FEATURES.map((f, i) => (
									<div className="col-lg-6 mb-4" key={i}>
										<div className="tower-c-glass-card">
											<div className="tower-c-glass-card-inner">
												<h4 className="tower-c-glass-card-title">{f.title}</h4>
												<p className="tower-c-glass-card-desc">{f.desc}</p>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</section> */}

					{/* Apartment Plans & Pricing - Premium Section */}
					{/* <section id="apartment-plans" className="tower-c-plans">
						<div className="container">
							<div className="tower-c-section-head text-center tower-c-animate" data-animate="up" style={{ '--tower-delay': '0ms' }}>
								<h2 className="tower-c-section-title">APARTMENT PLANS & PRICING</h2>
								<p className="tower-c-section-subtitle">Goldcrest Dreams Tower C, Emirates City Ajman</p>
								<div className="tower-c-section-line" />
							</div>
							<div className="row">
								{APARTMENT_PLANS.map((plan, i) => (
									<div className="col-lg-4 col-md-6 mb-4 tower-c-animate" key={i} data-animate="up" style={{ '--tower-delay': `${i * 80}ms` }}>
										<div className="tower-c-plan-card">
											<div className="tower-c-plan-card-glass">
												<h4 className="tower-c-plan-name">{plan.name}</h4>
												<p className="tower-c-plan-sqft">{plan.sqft}</p>
												<ul className="tower-c-plan-features">
													{plan.features.map((f, j) => (
														<li key={j}>{f}</li>
													))}
												</ul>
												<div className="tower-c-plan-pricing">
													<div className="tower-c-plan-price-row">
														<span className="tower-c-plan-label">Total Price</span>
														<span className="tower-c-plan-value">{plan.totalPrice}</span>
													</div>
													<div className="tower-c-plan-price-row">
														<span className="tower-c-plan-label">Per SQ FT</span>
														<span className="tower-c-plan-value">{plan.pricePerSqft}</span>
													</div>
													<div className="tower-c-plan-monthly">
														<span className="tower-c-plan-monthly-label">Monthly Payment</span>
														<span className="tower-c-plan-monthly-value">{plan.monthlyPayment} /MONTH</span>
														<p className="tower-c-plan-down tower-c-plan-down--in-monthly">{plan.downPayment}</p>
													</div>
												</div>
												<div className="fp-plan-buttons">
													<Link to="/contact-us" className="fp-plan-btn fp-plan-btn-touch">
														Get in Touch
													</Link>
													<button
														type="button"
														className="fp-plan-btn fp-plan-btn-custom"
														onClick={() => this.setState({ showCustomizedModal: true, selectedPlan: plan.name })}
													>
														Customized Plan
													</button>
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</section> */}

					{/* Interactive Room Gallery */}
					<section className="tower-c-room-gallery">
						<div className="container">
							<div className="tower-c-section-head text-center tower-c-animate" data-animate="up" style={{ '--tower-delay': '0ms' }}>
								<h2 className="tower-c-section-title">EXPLORE INTERIORS</h2>
								<p className="tower-c-section-subtitle">Click on a room type to view its pictures</p>
								<div className="tower-c-section-line" />
							</div>
							<div className="tower-c-room-tabs tower-c-animate" data-animate="up" style={{ '--tower-delay': '80ms' }}>
								{['living', 'bedroom', 'bathroom', 'kitchen'].map((room) => (
									<button
										key={room}
										className={`tower-c-room-tab ${activeRoom === room ? 'active' : ''}`}
										onClick={() => this.setState({ activeRoom: room })}
									>
										{room.charAt(0).toUpperCase() + room.slice(1)}
									</button>
								))}
							</div>
							<div className="tower-c-gallery-grid" key={activeRoom}>
								{galleryImages.map((img, i) => (
									<div key={`${activeRoom}-${i}`} className="tower-c-gallery-item">
										<div className="tower-c-gallery-item-inner">
											<img src={img} alt={`${activeRoom} ${i + 1}`} />
										</div>
									</div>
								))}
							</div>
						</div>
					</section>

					{/* Amenities Section */}
					<section className="tower-c-amenities">
						<div className="tower-c-amenities-bg" style={{ backgroundImage: `url(${amenity1})` }} />
						<div className="tower-c-amenities-overlay" />
						<div className="container position-relative">
							<h2 className="tower-c-amenities-title tower-c-animate" data-animate="up" style={{ '--tower-delay': '0ms' }}>AMENITIES</h2>
							<p className="tower-c-amenities-desc tower-c-animate" data-animate="up" style={{ '--tower-delay': '80ms' }}>
								The amenities at Goldcrest Dreams Towers are of the finest order and are integrated keeping your convenience in mind. Optimized to enhance your quality of living standards, the development inspires a whole new set of lifestyle.
							</p>
							<div className="row mt-5">
								<div className="col-md-6 mb-4 tower-c-animate" data-animate="left" style={{ '--tower-delay': '150ms' }}>
									<img src={gymImg} alt="Gym" className="tower-c-amenity-img" />
								</div>
								<div className="col-md-6 mb-4 tower-c-animate" data-animate="right" style={{ '--tower-delay': '200ms' }}>
									<img src={loungeImg} alt="Lounge" className="tower-c-amenity-img" />
								</div>
							</div>
						</div>
					</section>

					{/* Location & Travel Times */}
					<section className="tower-c-location">
						<div className="container">
							<div className="tower-c-section-head text-center tower-c-animate" data-animate="up" style={{ '--tower-delay': '0ms' }}>
								<h2 className="tower-c-section-title">PRIME LOCATION</h2>
								<p className="tower-c-section-subtitle">Everything you need is just minutes away</p>
								<div className="tower-c-section-line" />
							</div>
							<div className="row">
								{LOCATION_AMENITIES.map((item, i) => (
									<div className="col-lg-3 col-md-4 col-6 mb-4 tower-c-animate" key={i} data-animate="up" style={{ '--tower-delay': `${i * 60}ms` }}>
										<div className="tower-c-location-card">
											<i className={`las ${item.icon} tower-c-location-icon`} />
											<p className="tower-c-location-text">{item.title}</p>
										</div>
									</div>
								))}
							</div>
						</div>
					</section>

					{/* Investment Benefits */}
					<section className="tower-c-investment">
						<div className="container">
							<div className="tower-c-investment-grid">
								{INVESTMENT_BENEFITS.map((benefit, i) => (
									<div key={i} className="tower-c-investment-item tower-c-animate" data-animate="up" style={{ '--tower-delay': `${i * 80}ms` }}>
										<div className="tower-c-investment-icon">
											<i className="las la-check" />
										</div>
										<span>{benefit}</span>
									</div>
								))}
							</div>
						</div>
					</section>

					{/* Customized Plan Modal */}
					{this.state.showCustomizedModal && (
						<div className="fp-modal-overlay" onClick={() => this.setState({ showCustomizedModal: false })}>
							<div className="fp-modal" onClick={(e) => e.stopPropagation()}>
								<button
									type="button"
									className="fp-modal-close"
									aria-label="Close"
									onClick={() => this.setState({ showCustomizedModal: false })}
								>
									×
								</button>
								<div className="fp-modal-header">
									<h3>Request Customized Plan</h3>
									<p>Tell us your requirements and we&apos;ll create a tailored plan for you</p>
								</div>
								<form className="fp-modal-form" onSubmit={this.handleCustomizedPlanSubmit}>
									<input type="hidden" name="plan" value={this.state.selectedPlan} />
									<div className="fp-form-row fp-form-row-2">
										<div className="fp-form-group">
											<label htmlFor="fp-tc-name">Full Name *</label>
											<input id="fp-tc-name" name="name" type="text" required placeholder="Name" />
										</div>
										<div className="fp-form-group">
											<label htmlFor="fp-tc-phone">Phone *</label>
											<input id="fp-tc-phone" name="phone" type="tel" required placeholder="+971 67 412 344" />
										</div>
									</div>
									<div className="fp-form-group">
										<label htmlFor="fp-tc-plan-interest">Plan of Interest</label>
										<PlanSelect
											id="fp-tc-plan-interest"
											name="planInterest"
											plans={APARTMENT_PLANS}
											defaultValue={this.state.selectedPlan || (APARTMENT_PLANS[0] && APARTMENT_PLANS[0].name)}
										/>
									</div>
									<div className="fp-form-row fp-form-row-2">
										<div className="fp-form-group">
											<label htmlFor="fp-tc-installments">Installments</label>
											<PlanSelect
												id="fp-tc-installments"
												name="installments"
												plans={[
													{ name: '1 Year' },
													{ name: '2 Years' },
													{ name: '3 Years' },
													{ name: '4 Years' },
													{ name: '5 Years' },
												]}
												defaultValue="1 Year"
											/>
										</div>
										<div className="fp-form-group">
											<label htmlFor="fp-tc-advance-payment">Advance Payment</label>
											<input
												id="fp-tc-advance-payment"
												name="advancePayment"
												type="text"
												placeholder="e.g. AED 50,000"
											/>
										</div>
									</div>
									<div className="fp-form-group">
										<label htmlFor="fp-tc-requirements">Your Requirements *</label>
										<textarea
											id="fp-tc-requirements"
											name="requirements"
											rows="4"
											required
											placeholder="Describe your customization needs: room modifications, layout preferences, additional features, etc."
										/>
									</div>
									{this.state.customizedPlanError && (
										<p className="text-danger small mb-2">{this.state.customizedPlanError}</p>
									)}
									<button type="submit" className="fp-modal-submit" disabled={this.state.customizedPlanSubmitting}>
										{this.state.customizedPlanSubmitting ? 'Sending…' : 'Submit Request'}
									</button>
								</form>
							</div>
						</div>
					)}
					{this.state.floorPlanPopupPlan && FLOOR_PLAN_POPUP_GALLERY[this.state.floorPlanPopupPlan] && (() => {
						const gallery = FLOOR_PLAN_POPUP_GALLERY[this.state.floorPlanPopupPlan];
						const slideIdx = Math.min(this.state.floorPlanSlideIndex, gallery.length - 1);
						const slide = gallery[slideIdx];
						return (
						<div
							className="tower-c-fp-lightbox-overlay"
							role="dialog"
							aria-modal="true"
							aria-label="Floor plan images"
							onClick={this.closeFloorPlanPopup}
						>
							<div className="tower-c-fp-lightbox" onClick={(e) => e.stopPropagation()}>
								<button
									type="button"
									className="tower-c-fp-lightbox-close"
									aria-label="Close"
									onClick={this.closeFloorPlanPopup}
								>
									×
								</button>
								<p className="tower-c-fp-lightbox-heading">{this.state.floorPlanPopupPlan}</p>
								<div className="tower-c-fp-lightbox-body">
									{gallery.length > 1 && (
										<button
											type="button"
											className="tower-c-fp-lightbox-arrow tower-c-fp-lightbox-arrow-prev"
											aria-label="Previous floor plan image"
											onClick={(e) => { e.stopPropagation(); this.floorPlanSliderPrev(); }}
										>
											‹
										</button>
									)}
									<figure className="tower-c-fp-lightbox-figure">
										{slide.caption && (
											<figcaption className="tower-c-fp-lightbox-caption">{slide.caption}</figcaption>
										)}
										<div className="tower-c-fp-lightbox-img-wrap">
											<img
												src={slide.src}
												alt={slide.caption || this.state.floorPlanPopupPlan}
												className="tower-c-fp-lightbox-img"
											/>
										</div>
									</figure>
									{gallery.length > 1 && (
										<button
											type="button"
											className="tower-c-fp-lightbox-arrow tower-c-fp-lightbox-arrow-next"
											aria-label="Next floor plan image"
											onClick={(e) => { e.stopPropagation(); this.floorPlanSliderNext(); }}
										>
											›
										</button>
									)}
								</div>
							</div>
						</div>
						);
					})()}
				</div>
				<FooterPremium />
				<style>{`
					/* Smooth scroll animations - CSS transitions (GPU-accelerated, no glitching) */
					.tower-c-animate {
						opacity: 0;
						transform: translate3d(0, 0, 0);
						transition: opacity 0.8s cubic-bezier(0.33, 1, 0.68, 1),
							transform 0.8s cubic-bezier(0.33, 1, 0.68, 1);
						backface-visibility: hidden;
					}
					.tower-c-animate[data-animate="up"] {
						transform: translate3d(0, 24px, 0);
					}
					.tower-c-animate[data-animate="left"] {
						transform: translate3d(-24px, 0, 0);
					}
					.tower-c-animate[data-animate="right"] {
						transform: translate3d(24px, 0, 0);
					}
					.tower-c-animate.tower-c-visible {
						opacity: 1;
						transform: translate3d(0, 0, 0);
						transition-delay: var(--tower-delay, 0ms);
					}

					.tower-c-premium {
						background: #f3f1ef;
						color: #1a1a1a;
						scroll-behavior: smooth;
					}
					.min-vh-75 { min-height: 75vh; }

					/* Milestone Achievement */
					.tower-c-milestone {
						position: relative;
						overflow: hidden;
						padding: 90px 0;
						background: #f7f5f2;
						color: #1a1a1a;
					}
					.tower-c-milestone__bg {
						position: absolute;
						inset: 0;
						background-size: cover;
						background-position: center;
						background-repeat: no-repeat;
						z-index: 0;
					}
					.tower-c-milestone__wash {
						position: absolute;
						inset: 0;
						z-index: 1;
						background: linear-gradient(
							105deg,
							rgba(255, 255, 255, 0.72) 0%,
							rgba(255, 255, 255, 0.55) 42%,
							rgba(255, 255, 255, 0.38) 100%
						);
						pointer-events: none;
					}
					.tower-c-milestone__inner {
						position: relative;
						z-index: 2;
					}
					.tower-c-milestone__row {
						align-items: center;
					}
					.tower-c-milestone__visual {
						position: relative;
						border-radius: 20px;
						overflow: hidden;
						background: transparent;
						box-shadow: 0 22px 50px rgba(34, 30, 22, 0.14);
						border: 1px solid rgba(255, 255, 255, 0.65);
					}
					.tower-c-milestone__visual img {
						display: block;
						width: 100%;
						height: auto;
						object-fit: contain;
						border-radius: 20px;
					}
					.tower-c-milestone__copy {
						padding-left: 28px;
						max-width: 480px;
					}
					.tower-c-milestone__eyebrow {
						display: block;
						font-size: 0.8rem;
						font-weight: 600;
						letter-spacing: 0.18em;
						text-transform: uppercase;
						color: #b8975f;
						margin-bottom: 14px;
					}
					.tower-c-milestone__title {
						margin-bottom: 16px !important;
						line-height: 1.15;
					}
					.tower-c-milestone__rule {
						width: 56px;
						height: 3px;
						border-radius: 2px;
						background: linear-gradient(90deg, #b8975f, #d4bc7f);
						margin-bottom: 22px;
					}
					.tower-c-milestone__text {
						margin-bottom: 28px !important;
						color: #3a3a3a;
					}
					.tower-c-milestone__badge {
						display: inline-flex;
						align-items: center;
						gap: 12px;
						padding: 14px 20px;
						margin: 0 0 28px;
						background: rgba(255, 255, 255, 0.92);
						backdrop-filter: blur(8px);
						-webkit-backdrop-filter: blur(8px);
						border: 1px solid rgba(184, 151, 95, 0.28);
						border-radius: 999px;
						font-size: 12px;
						font-weight: 600;
						letter-spacing: 0.08em;
						text-transform: uppercase;
						color: #1a1a1a;
						box-shadow: 0 10px 28px rgba(34, 30, 22, 0.08);
					}
					.tower-c-milestone__badge strong {
						color: #b8975f;
						font-weight: 700;
					}
					.tower-c-milestone__badge-check {
						display: inline-flex;
						align-items: center;
						justify-content: center;
						width: 24px;
						height: 24px;
						border-radius: 50%;
						background: #b8975f;
						color: #fff;
						font-size: 12px;
						font-weight: 700;
						flex-shrink: 0;
					}
					.tower-c-milestone__thanks {
						font-size: 0.98rem;
						line-height: 1.7;
						color: #555;
						margin: 0 0 18px;
						max-width: 400px;
					}
					.tower-c-milestone__brand {
						display: inline-block;
						font-size: 0.85rem;
						font-weight: 600;
						letter-spacing: 0.14em;
						text-transform: uppercase;
						color: #1a1a1a;
						padding-top: 16px;
						border-top: 1px solid rgba(0, 0, 0, 0.08);
					}
					@media (max-width: 991.98px) {
						.tower-c-milestone {
							padding: 64px 0;
						}
						.tower-c-milestone__copy {
							padding-left: 0;
							max-width: none;
							padding-top: 8px;
						}
						.tower-c-milestone__wash {
							background: linear-gradient(
								180deg,
								rgba(255, 255, 255, 0.78) 0%,
								rgba(255, 255, 255, 0.62) 100%
							);
						}
					}
					@media (max-width: 575.98px) {
						.tower-c-milestone {
							padding: 48px 0;
						}
						.tower-c-milestone__visual,
						.tower-c-milestone__visual img {
							border-radius: 14px;
						}
						.tower-c-milestone__badge {
							font-size: 11px;
							padding: 12px 16px;
							border-radius: 14px;
						}
					}

					/* Hero */
					.tower-c-hero { position: relative; overflow: hidden; }
					.tower-c-hero-bg {
						position: absolute; inset: 0;
						background-size: cover; background-position: center;
					}
					.tower-c-hero-overlay {
						position: absolute; inset: 0;
						background: linear-gradient(90deg, rgba(243,241,239,0.95) 0%, rgba(243,241,239,0.7) 60%, transparent 100%);
					}
					.tower-c-hero-title {
						font-size: clamp(2.5rem, 5vw, 4rem);
						font-weight: 800;
						color: #1a1a1a;
						line-height: 1.15;
						margin-bottom: 1.5rem;
						letter-spacing: 0.02em;
					}
					.tower-c-hero-desc {
						font-size: 1.05rem;
						line-height: 1.8;
						color: #1a1a1a;
						max-width: 540px;
						margin-bottom: 2rem;
					}

					/* Glass Buttons */
					.tower-c-glass-btn {
						display: inline-flex;
						align-items: center;
						gap: 0.5rem;
						padding: 16px 36px;
						font-size: 1rem;
						font-weight: 700;
						letter-spacing: 0.08em;
						text-decoration: none;
						border-radius: 12px;
						border: 1px solid rgba(0,0,0,0.2);
						background: rgba(255,255,255,0.8);
						backdrop-filter: blur(16px);
						-webkit-backdrop-filter: blur(16px);
						color: #1a1a1a;
						transition: all 0.35s ease;
						box-shadow: 0 8px 32px rgba(0,0,0,0.08);
					}
					.tower-c-glass-btn:hover {
						background: rgba(255,255,255,0.95);
						border-color: rgba(0,0,0,0.3);
						transform: translateY(-2px);
						box-shadow: 0 12px 40px rgba(0,0,0,0.12);
						color: #1a1a1a;
					}
					.tower-c-glass-btn-primary {
						background: rgba(26,71,42,0.9);
						border-color: rgba(26,71,42,0.5);
						color: #fff;
					}
					.tower-c-glass-btn-primary:hover { background: rgba(26,71,42,0.95); color: #fff; }
					.tower-c-glass-btn-light {
						background: rgba(255,255,255,0.9);
						border-color: rgba(0,0,0,0.3);
						color: #1a1a1a;
					}
					.tower-c-customize-btn {
						padding: 18px 48px;
						font-size: 1.1rem;
						background: rgba(255,255,255,0.9);
						border: 1px solid rgba(0,0,0,0.2);
						color: #1a1a1a;
					}
					.tower-c-customize-btn:hover {
						background: #fff;
						border-color: rgba(0,0,0,0.3);
						color: #1a1a1a;
					}

					/* Apartment Intro - #f3f1ef */
					.tower-c-apartment-intro {
						padding: 100px 0;
						background: white;
					}
					.tower-c-section-title-dark {
						font-size: clamp(2rem, 4vw, 3rem);
						font-weight: 800;
						color: #1a1a1a;
						margin-bottom: 1.5rem;
						letter-spacing: 0.03em;
					}
					.tower-c-intro-text {
						font-size: 1.05rem;
						line-height: 1.85;
						color: #1a1a1a;
						margin-bottom: 1.25rem;
					}
					.tower-c-brochure-btn {
						display: inline-flex;
						align-items: center;
						gap: 1rem;
						padding: 7px 7px;
						// background: #ffffff;
						border: 1px solid #1a1a1a;
						border-radius: 10px;
						color: #1a1a1a;
						text-decoration: none;
						transition: all 0.3s ease;
						// margin-top: 1rem;
					}
					.tower-c-brochure-btn:hover {
					border: 1px solid #b8975f!important;
						background: #b8975f!important;
						color: #ffffff;
						text-decoration: none;
					}
					.tower-c-brochure-icon {
						font-size: 2rem;
					}
					.tower-c-brochure-btn .tower-c-brochure-icon i {
						color: inherit;
					}
					.tower-c-brochure-text {
						display: flex;
						flex-direction: column;
						align-items: flex-start;
					}
					.tower-c-brochure-title {
						font-size: 1rem;
						font-weight: 700;
						letter-spacing: 0.05em;
					}
					.tower-c-brochure-download {
						font-size: 0.85rem;
						font-weight: 600;
						margin-top: 0.2rem;
					}
					.tower-c-brochure-download i {
						margin-left: 0.25rem;
						font-size: 0.75rem;
					}
					.tower-c-interior-grid {
						display: grid;
						grid-template-columns: 1fr 1fr;
						grid-template-rows: auto auto;
						gap: 12px;
						margin-top: 2rem;
					}
					.tower-c-interior-main {
						grid-row: span 2;
						width: 100%;
						height: 100%;
						object-fit: cover;
						border-radius: 12px;
						box-shadow: 0 12px 40px rgba(0,0,0,0.4);
					}
					.tower-c-interior-small {
						width: 100%;
						height: 140px;
						object-fit: cover;
						border-radius: 12px;
						box-shadow: 0 8px 24px rgba(0,0,0,0.3);
					}
					.tower-c-building-visual {
						height: 480px;
						border-radius: 20px;
						background-size: cover;
						background-position: center;
						box-shadow: 0 20px 60px rgba(0,0,0,0.15);
						border: 1px solid rgba(0,0,0,0.06);
					}

					/* Award-style section - white */
					.tower-c-award-section.award-section {
						padding: 40px 0 64px;
						background: #ffffff;
						position: relative;
						overflow: hidden;
					}
					.tower-c-award-section.award-section::before {
						content: '';
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23e39001' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
						opacity: 0.5;
					}
					.tower-c-award-section .award-container {
						position: relative;
						z-index: 1;
					}
					.tower-c-award-section .award-header {
						text-align: center;
						margin-bottom: 0;
					}
					.tower-c-award-section .award-title {
						font-size: 42px;
						font-weight: 800;
						color: #1a1a1a;
						margin-bottom: 20px;
						line-height: 1.2;
						letter-spacing: -1px;
					}
					.tower-c-award-section .award-title span {
						color: #000;
					}
					.tower-c-award-section .award-content {
						font-size: 1rem;
						line-height: 1.8;
						color: #1a1a1a;
						max-width: 900px;
						margin: 0 auto;
					}
					.tower-c-award-section .award-content p {
						margin-bottom: 1rem;
					}
					.tower-c-award-section .award-content p:last-child {
						margin-bottom: 0;
					}
					.tower-c-award-section .award-content strong {
						color: #1a1a1a;
						font-weight: 700;
					}

					/* Facilities For Lifestyle - #f3f1ef */
					.tower-c-facilities {
						padding: 100px 0;
						background: #f3f1ef;
						position: relative;
					}
					.tower-c-facilities-header {
						display: flex;
						align-items: flex-start;
						justify-content: space-between;
						flex-wrap: wrap;
						gap: 20px;
						margin-bottom: 50px;
					}
					.tower-c-facilities-label {
						display: block;
						font-size: 0.9rem;
						font-weight: 600;
						color: #1a1a1a;
						letter-spacing: 0.1em;
						margin-bottom: 8px;
					}
					.tower-c-facilities-title {
						font-size: clamp(2rem, 4vw, 2.75rem);
						font-weight: 800;
						color: #1a1a1a;
						margin: 0;
						letter-spacing: 0.02em;
					}
					.tower-c-facilities-viewmore {
						padding: 12px 28px;
						font-size: 0.95rem;
						font-weight: 600;
						background: rgba(255,255,255,0.9);
						border: 1px solid rgba(0,0,0,0.2);
						border-radius: 8px;
						color: #1a1a1a;
						text-decoration: none;
						transition: all 0.3s ease;
						backdrop-filter: blur(8px);
					}
					.tower-c-facilities-viewmore:hover {
						background: #fff;
						border-color: rgba(0,0,0,0.3);
						color: #1a1a1a;
						transform: translateY(-2px);
					}
					.tower-c-facilities-grid {
						display: grid;
						grid-template-columns: repeat(2, 1fr);
						gap: 30px;
					}
					.tower-c-facility-card {
						display: flex;
						align-items: stretch;
						gap: 24px;
						background: rgba(255,255,255,0.9);
						backdrop-filter: blur(16px);
						-webkit-backdrop-filter: blur(16px);
						border: 1px solid rgba(0,0,0,0.08);
						border-radius: 16px;
						overflow: hidden;
						transition: all 0.35s ease;
						box-shadow: 0 4px 20px rgba(0,0,0,0.06);
					}
					.tower-c-facility-card:hover {
						background: #fff;
						border-color: rgba(0,0,0,0.12);
						transform: translateY(-4px);
						box-shadow: 0 20px 50px rgba(0,0,0,0.1);
					}
					.tower-c-facility-image {
						flex: 0 0 180px;
						min-height: 160px;
						overflow: hidden;
					}
					.tower-c-facility-image img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						display: block;
					}
					.tower-c-facility-content {
						flex: 1;
						padding: 24px 24px 24px 0;
						display: flex;
						flex-direction: column;
						justify-content: center;
					}
					.tower-c-facility-title {
						font-size: 1.35rem;
						font-weight: 700;
						color: #1a1a1a;
						margin-bottom: 10px;
					}
					.tower-c-facility-desc {
						font-size: 0.95rem;
						line-height: 1.65;
						color: #1a1a1a;
						margin: 0;
					}
					@media (max-width: 991px) {
						.tower-c-facilities-grid {
							grid-template-columns: 1fr;
						}
						.tower-c-facility-image {
							flex: 0 0 140px;
							min-height: 140px;
						}
					}
					@media (max-width: 575px) {
						.tower-c-facility-card {
							flex-direction: column;
						}
						.tower-c-facility-image {
							flex: none;
							width: 100%;
							min-height: 200px;
						}
						.tower-c-facility-content {
							padding: 20px 24px 24px;
						}
					}

					/* Feature Cards */
					.tower-c-features {
						padding: 80px 0;
						background: #f3f1ef;
					}
					.tower-c-glass-card {
						background: rgba(255,255,255,0.9);
						backdrop-filter: blur(20px);
						-webkit-backdrop-filter: blur(20px);
						border: 1px solid rgba(0,0,0,0.08);
						border-radius: 16px;
						padding: 32px;
						transition: all 0.35s ease;
						box-shadow: 0 4px 20px rgba(0,0,0,0.06);
					}
					.tower-c-glass-card:hover {
						background: #fff;
						border-color: rgba(0,0,0,0.12);
						transform: translateY(-4px);
						box-shadow: 0 20px 50px rgba(0,0,0,0.1);
					}
					.tower-c-glass-card-title {
						font-size: 1.25rem;
						font-weight: 700;
						color: #1a1a1a;
						margin-bottom: 0.75rem;
					}
					.tower-c-glass-card-desc {
						font-size: 0.95rem;
						color: #1a1a1a;
						line-height: 1.6;
						margin: 0;
					}

					/* Floor Plans - white */
					.tower-c-floor-plans {
						padding: 100px 0;
						background: #ffffff;
					}
					.tower-c-floor-plan-row {
						margin-bottom: 80px;
					}
					.tower-c-floor-plan-row:last-child {
						margin-bottom: 0;
					}
					.tower-c-floor-plan-image {
						overflow: visible;
					}
					.tower-c-floor-plan-image img {
						width: 100%;
						height: auto;
						display: block;
						object-fit: contain;
					}
					.tower-c-floor-plan-equal-height .row.align-items-stretch > [class*="col-"] {
						display: flex;
						flex-direction: column;
					}
					.tower-c-floor-plan-equal-height .tower-c-floor-plan-content-equal {
						flex: 1;
						display: flex;
						flex-direction: column;
					}
					.tower-c-floor-plan-equal-height .tower-c-floor-plan-image-equal {
						flex: 1;
						min-height: 320px;
						display: flex;
						align-items: stretch;
					}
					.tower-c-floor-plan-equal-height .tower-c-floor-plan-image-equal img {
						width: 100%;
						min-height: 320px;
						height: 100%;
						object-fit: cover;
						flex: 1;
					}
					/* Image column on the right: slanted left edge (matches design reference) */
					.tower-c-floor-plan-equal-height .tower-c-floor-plan-image--slant-right img {
					    height: 200px;
					min-height: 410px;
						-webkit-clip-path: polygon(6% 0, 100% 0, 100% 100%, 0 100%);
						clip-path: polygon(6% 0, 100% 0, 100% 100%, 0 100%);
						border-radius: 0 16px 16px 0;
					}
					/* Image column on the left: mirrored slant on right edge */
					.tower-c-floor-plan-equal-height .tower-c-floor-plan-image--slant-left img {
						height: 200px;
						min-height: 410px;
						-webkit-clip-path: polygon(0 0, 94% 0, 100% 100%, 0 100%);
						clip-path: polygon(0 0, 94% 0, 100% 100%, 0 100%);
						border-radius: 16px 0 0 16px;
					}

					/* Smooth fade/scale when swapping the right curved image on hover */
					.tower-c-floor-plan-swap-img {
						animation: tower-c-floor-plan-img-swap 0.35s ease both;
						will-change: opacity, transform;
					}

					@keyframes tower-c-floor-plan-img-swap {
						from {
							opacity: 0;
							transform: scale(0.98);
						}
						to {
							opacity: 1;
							transform: scale(1);
						}
					}

					.tower-c-floor-plan-features-grid {
						display: grid;
						grid-template-columns: 1fr 1fr;
						gap: 0 2rem;
						margin-bottom: 1.25rem;
					}
					.tower-c-floor-plan-features-grid .tower-c-plan-features {
						margin-bottom: 0;
					}
					@media (max-width: 575px) {
						.tower-c-floor-plan-features-grid {
							grid-template-columns: 1fr;
							gap: 0;
						}
					}
					.tower-c-floor-plan-content {
						padding: 0;
					}
					.tower-c-floor-plan-see-link {
					text-align: left;
						display: inline-block;
						margin: 0 0 0.65rem;
						padding: 0;
						border: none;
						background: none;
						font-size: 0.82rem;
						font-weight: 600;
						letter-spacing: 0.02em;
						color:#b8975f;
						text-decoration: underline;
						text-underline-offset: 2px;
						cursor: pointer;
						transition: color 0.2s ease;
						line-height: 1.3;
					}
					.tower-c-floor-plan-see-link:hover {
						color: #b8975f;
					}
					.tower-c-fp-lightbox-overlay {
						position: fixed;
						inset: 0;
						z-index: 10000;
						background: rgba(0, 0, 0, 0.72);
						backdrop-filter: blur(8px);
						-webkit-backdrop-filter: blur(8px);
						display: flex;
						align-items: center;
						justify-content: center;
						padding: 1rem;
						animation: tower-c-fp-lb-fade 0.28s ease forwards;
					}
					@keyframes tower-c-fp-lb-fade {
						from { opacity: 0; }
						to { opacity: 1; }
					}
					.tower-c-fp-lightbox {
						position: relative;
						width: 100%;
						max-width: min(920px, 96vw);
						max-height: 90vh;
						overflow: hidden;
						background: #ffffff;
						border-radius: 16px;
						box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28);
						padding: 1.35rem 1.35rem 1.5rem;
						animation: tower-c-fp-lb-pop 0.34s cubic-bezier(0.33, 1, 0.68, 1) forwards;
						display: flex;
						flex-direction: column;
						min-height: 0;
					}
					@keyframes tower-c-fp-lb-pop {
						from {
							opacity: 0;
							transform: scale(0.96) translateY(14px);
						}
						to {
							opacity: 1;
							transform: scale(1) translateY(0);
						}
					}
					.tower-c-fp-lightbox-close {
						position: absolute;
						top: 0.65rem;
						right: 0.65rem;
						width: 38px;
						height: 38px;
						border: 1px solid rgba(0, 0, 0, 0.1);
						border-radius: 50%;
						background: rgba(255, 255, 255, 0.95);
						font-size: 1.35rem;
						line-height: 1;
						color: #1a1a1a;
						cursor: pointer;
						transition: background 0.2s ease, transform 0.2s ease;
					}
					.tower-c-fp-lightbox-close:hover {
						background: #f3f1ef;
						transform: scale(1.05);
					}
					.tower-c-fp-lightbox-heading {
						font-size: 0.95rem;
						font-weight: 700;
						color: #1a1a1a;
						margin: 0 2.5rem 1rem 0;
						padding: 0;
						line-height: 1.35;
					}
					.tower-c-fp-lightbox-body {
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: center;
						gap: 0.35rem;
						flex: 1 1 auto;
						min-height: 0;
					}
					.tower-c-fp-lightbox-arrow {
						flex-shrink: 0;
						width: 42px;
						height: 42px;
						border: 1px solid rgba(0, 0, 0, 0.12);
						border-radius: 50%;
						background: rgba(255, 255, 255, 0.98);
						font-size: 1.75rem;
						line-height: 1;
						padding: 0;
						color: #1a1a1a;
						cursor: pointer;
						transition: background 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
						align-self: center;
					}
					.tower-c-fp-lightbox-arrow:hover {
						background: #f3f1ef;
						border-color: rgba(26, 71, 42, 0.35);
						transform: scale(1.05);
					}
					.tower-c-fp-lightbox-figure {
						margin: 0;
						flex: 1 1 auto;
						min-width: 0;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
					}
					.tower-c-fp-lightbox-caption {
						font-size: 0.8rem;
						font-weight: 600;
						color: #1a472a;
						margin-bottom: 0.45rem;
						letter-spacing: 0.03em;
						text-align: center;
						width: 100%;
					}
					.tower-c-fp-lightbox-img-wrap {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 100%;
						max-height: min(68vh, 620px);
					}
					.tower-c-fp-lightbox-img {
						display: block;
						max-width: 100%;
						max-height: min(68vh, 620px);
						width: auto;
						height: auto;
						object-fit: contain;
						border-radius: 10px;
						border: 1px solid rgba(0, 0, 0, 0.08);
					}
					/* Try Floor Plans: tighter vertical rhythm + CTA pinned to bottom of column */
					.tower-c-try-floor-plans.tower-c-floor-plans {
						padding: 72px 0;
					}
					.tower-c-try-floor-plans .tower-c-floor-plan-row {
						margin-bottom: 56px;
					}
					.tower-c-try-floor-plans .tower-c-floor-plan-equal-height .tower-c-floor-plan-content-equal {
						padding-top: 0;
						padding-bottom: 0.125rem;
						min-height: 0;
					}
					.tower-c-try-floor-plans .tower-c-plan-sqft {
						margin-bottom: 0.45rem;
					}
					.tower-c-try-floor-plans .tower-c-floor-plan-see-link {
						margin-bottom: 0.45rem;
					}
					.tower-c-try-floor-plans .tower-c-floor-plan-features-grid {
						margin-bottom: 0.65rem;
					}
					.tower-c-try-floor-plans .tower-c-plan-features li {
						margin-bottom: 0.45rem;
					}
					.tower-c-try-floor-plans .tower-c-plan-features li:last-child {
						margin-bottom: 0;
					}
					.tower-c-try-floor-plans .tower-c-plan-pricing {
						padding-top: 0.65rem;
					}
					.tower-c-try-floor-plans .tower-c-plan-price-row {
						margin-bottom: 0.35rem;
					}
					.tower-c-try-floor-plans .tower-c-plan-monthly {
						margin-top: 0.6rem;
						margin-bottom:5px;
						padding: 8px 10px;
					}
					.tower-c-try-floor-plans .tower-c-plan-monthly-label {
						margin-bottom: 0.15rem;
					}
					.tower-c-try-floor-plans .tower-c-try-plan-cta {
						margin-top: 0;
						margin-bottom: 0;
						padding-top: 0;
					}
					.tower-c-try-floor-plans .tower-c-try-plan-btn {
						width: 100%;
						display: inline-flex;
						align-items: center;
						justify-content: center;
						text-align: center;
						padding: 10px 6px;
						font-size: 0.92rem;
						font-weight: 600;
						letter-spacing: 0.03em;
						line-height: 1.35;
						color: #fff;
						background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 40%,rgba(0, 0, 0, 0.7) 100%);
						border: 1px solid rgba(0, 0, 0, 0.12);
						border-radius: 5px;
						cursor: pointer;
						transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.2s ease;
						box-shadow: 0 6px 20px rgba(26, 71, 42, 0.18);
					}
					.tower-c-try-floor-plans .tower-c-try-plan-btn:hover {
					    background: #b8975f!important;
						transform: translateY(-2px);
						box-shadow: 0 10px 28px rgba(0, 0, 0, 0.14);
						filter: brightness(1.06);
					}
					.tower-c-try-floor-plans .tower-c-try-plan-btn:focus {
						outline: none;
						box-shadow: 0 0 0 3px rgba(184, 151, 95, 0.45);
					}
					.tower-c-floor-plan-title {
						font-size: 1.75rem;
						font-weight: 800;
						color: #1a472a;
						margin-bottom: 1rem;
						letter-spacing: 0.02em;
					}
					.tower-c-floor-plan-desc {
						font-size: 1.05rem;
						line-height: 1.8;
						color: #1a1a1a;
						margin-bottom: 1.25rem;
					}
					.tower-c-floor-plan-features {
						list-style: none;
						padding: 0;
						margin: 0;
					}
					.tower-c-floor-plan-features li {
						position: relative;
						padding-left: 1.5rem;
						margin-bottom: 0.6rem;
						font-size: 0.95rem;
						color: #1a1a1a;
						line-height: 1.5;
					}
					.tower-c-floor-plan-features li:before {
						content: '';
						position: absolute;
						left: 0;
						top: 0.5em;
						width: 6px;
						height: 6px;
						background: #1a472a;
						border-radius: 50%;
					}
					@media (max-width: 991px) {
						.tower-c-floor-plan-row { margin-bottom: 60px; }
					}

					/* Plans - #f3f1ef (alternating) */
					.tower-c-plans {
						padding: 100px 0;
						background: #f3f1ef;
					}
					.tower-c-section-head { margin-bottom: 3rem; }
					.tower-c-section-title {
						font-size: clamp(2rem, 4vw, 2.75rem);
						font-weight: 800;
						color: #1a1a1a;
						margin-bottom: 0.5rem;
						letter-spacing: 0.04em;
					}
					.tower-c-section-subtitle {
						font-size: 1rem;
						color: #1a1a1a;
						margin-bottom: 1rem;
					}
					.tower-c-section-line {
						width: 80px;
						height: 4px;
						background: linear-gradient(90deg, #b8975f,rgb(0, 0, 0));
						border-radius: 2px;
						margin: 0 auto;
					}
					.tower-c-plan-card {
						height: 100%;
					}
					.tower-c-plan-card-glass {
						background: rgba(255,255,255,0.9);
						backdrop-filter: blur(16px);
						border: 1px solid rgba(0,0,0,0.08);
						border-radius: 16px;
						padding: 28px;
						height: 100%;
						transition: all 0.35s ease;
						box-shadow: 0 4px 20px rgba(0,0,0,0.06);
					}
					.tower-c-plan-card-glass:hover {
						background: #fff;
						border-color: rgba(0,0,0,0.12);
						transform: translateY(-4px);
						box-shadow: 0 16px 48px rgba(0,0,0,0.1);
					}
					.tower-c-plan-name {
						font-size: 1rem;
						font-weight: bold;
						color: black;
						margin-bottom: 0.25rem;
						line-height: 1.3;
					}
					.tower-c-plan-sqft {
						font-size: 0.9rem;
						color: #1a1a1a;
						margin-bottom: 1rem;
					}
					.tower-c-plan-features {
						list-style: none;
						padding: 0;
						margin: 0 0 1.25rem 0;
						font-size: 0.8rem;
						color: #1a1a1a;
						line-height: 1.45;
					}
					.tower-c-plan-features li {
						cursor: pointer;
						display: block;
						margin-bottom: 0.45rem;
						padding: 3px 0px;
						text-align: center;
						font-weight: 600;
						letter-spacing: 0.02em;
						color: #1a1a1a;
						background: #ffffff;
						border: 1px solid rgba(184, 151, 95, 0.42);
						border-radius: 999px;
						box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
						transition: border-color 0.22s ease, box-shadow 0.22s ease, background 0.22s ease, transform 0.2s ease;
					}
					.tower-c-plan-features li:last-child {
						margin-bottom: 0;
					}
					.tower-c-floor-plan-features-grid .tower-c-plan-features li:hover {
						border-color: rgba(184, 151, 95, 0.88);
						background: linear-gradient(180deg, #fffefb 0%, #ffffff 100%);
						box-shadow: 0 4px 14px rgba(184, 151, 95, 0.16);
						transform: translateY(-1px);
					}
					.tower-c-plan-features li:before {
						content: none !important;
						display: none !important;
					}
					.tower-c-plan-pricing {
						border-top: 1px solid rgba(0,0,0,0.1);
						padding-top: 1rem;
					}
					.tower-c-plan-price-row {
						display: flex;
						justify-content: space-between;
						margin-bottom: 0.5rem;
						font-size: 0.9rem;
					}
					.tower-c-plan-label { color: #1a1a1a; }
					.tower-c-plan-value { color: #1a1a1a; font-weight: 600; }
					.tower-c-plan-monthly {
						display: flex;
						flex-direction: column;
						margin-top: 1rem;
						padding: 12px;
						background: #0000000f;
						border-radius: 10px;
					}
					.tower-c-plan-monthly-label {
						font-size: 0.8rem;
						color: #1a1a1a;
						margin-bottom: 0.25rem;
					}
					.tower-c-plan-monthly-value {
						font-size: 1.25rem;
						font-weight: 800;
						color: #1a1a1a;
					}
					.tower-c-plan-down {
						margin: 0;
					}
					.tower-c-plan-down--in-monthly {
						margin: 0.4rem 0 0;
						padding-top: 0.4rem;
						border-top: 1px solid rgba(0, 0, 0, 0.1);
						font-size: 0.68rem;
						font-weight: 600;
						letter-spacing: 0.06em;
						text-transform: uppercase;
						color: #1a1a1a;
						line-height: 1.3;
						text-align: center;
					}

					/* Room Gallery - #ffffff (alternating) */
					.tower-c-room-gallery {
						padding: 0px 0;
						background: #ffffff;
					}
					.tower-c-room-tabs {
						display: flex;
						flex-wrap: wrap;
						justify-content: center;
						gap: 10px;
						margin-bottom: 2.5rem;
					}
					.tower-c-room-tab {
						padding: 7px 13px;
						font-size: 0.95rem;
						font-weight: 600;
						background: #ffffff;
						border: 1px solid rgba(0,0,0,0.18);
						border-radius: 10px;
						color: #1a1a1a;
						cursor: pointer;
						transition: all 0.3s ease;
					}
					.tower-c-room-tab:hover {
						background: #ffffff;
						border-color: rgba(0,0,0,0.25);
						color: #1a1a1a;
					}
					.tower-c-room-tab.active {
						    background: #0000000f;
    border: 1px solid #000000;
    color: #000000;
					}
					.tower-c-gallery-grid {
						display: grid;
						grid-template-columns: repeat(4, minmax(0, 1fr));
						grid-template-rows: repeat(2, auto);
						gap: 20px;
					}
					@media (max-width: 991px) {
						.tower-c-gallery-grid {
							grid-template-columns: repeat(2, minmax(0, 1fr));
							grid-template-rows: none;
						}
					}
					@media (max-width: 575px) {
						.tower-c-gallery-grid {
							grid-template-columns: 1fr;
						}
					}
					.tower-c-gallery-item-inner {
						overflow: hidden;
						border-radius: 14px;
						border: 1px solid rgba(0,0,0,0.08);
						box-shadow: 0 10px 30px rgba(0,0,0,0.1);
						transition: transform 0.35s ease;
					}
					.tower-c-gallery-item-inner:hover { transform: scale(1.03); }
					.tower-c-gallery-item-inner img {
						width: 100%;
						height: 240px;
						object-fit: cover;
						display: block;
					}

					/* Amenities */
					.tower-c-amenities {
						position: relative;
						padding: 100px 0;
						overflow: hidden;
					}
					.tower-c-amenities-bg {
						position: absolute;
						inset: 0;
						background-size: cover;
						background-position: center;
					}
					.tower-c-amenities-overlay {
						position: absolute;
						inset: 0;
						background: rgba(255,255,255,0.92);
					}
					.tower-c-amenities-title {
						font-size: 3rem;
						font-weight: 800;
						color: #1a1a1a;
						margin-bottom: 1rem;
						letter-spacing: 0.05em;
					}
					.tower-c-amenities-desc {
						font-size: 1.1rem;
						line-height: 1.8;
						color: #1a1a1a;
						max-width: 700px;
					}
					.tower-c-amenity-img {
						width: 100%;
						height: 280px;
						object-fit: cover;
						border-radius: 16px;
						box-shadow: 0 16px 48px rgba(0,0,0,0.15);
					}

					/* Location - #f3f1ef */
					.tower-c-location {
						padding: 100px 0;
						background: #f3f1ef;
					}
					.tower-c-location-card {
						background: rgba(255,255,255,0.9);
						backdrop-filter: blur(12px);
						border: 1px solid rgba(0,0,0,0.08);
						border-radius: 14px;
						padding: 24px;
						text-align: center;
						height: 100%;
						transition: all 0.3s ease;
						box-shadow: 0 4px 20px rgba(0,0,0,0.06);
					}
					.tower-c-location-card:hover {
						background: #fff;
						border-color: rgba(26,71,42,0.3);
						transform: translateY(-3px);
						box-shadow: 0 12px 30px rgba(0,0,0,0.1);
					}
					.tower-c-location-icon {
						font-size: 2rem;
						color: #d59319;
						display: block;
						margin-bottom: 0.75rem;
					}
					.tower-c-location-text {
						font-size: 0.9rem;
						color: #1a1a1a;
						margin: 0;
						line-height: 1.4;
					}

					/* Investment - white */
					.tower-c-investment {
						padding: 80px 0;
						background: #ffffff;
					}
					.tower-c-investment-grid {
						display: grid;
						grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
						gap: 24px;
					}
					.tower-c-investment-item {
						display: flex;
						align-items: center;
						gap: 1rem;
						background: rgba(255,255,255,0.9);
						backdrop-filter: blur(12px);
						border: 1px solid rgba(0,0,0,0.08);
						border-radius: 12px;
						padding: 20px 24px;
						font-size: 1rem;
						font-weight: 600;
						color: #1a1a1a;
						box-shadow: 0 4px 20px rgba(0,0,0,0.06);
					}
					.tower-c-investment-icon {
						width: 40px;
						height: 40px;
						background: #e5c89342;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #d59319;
						flex-shrink: 0;
					}

					/* CTA */
					.tower-c-cta {
						position: relative;
						padding: 120px 0;
						text-align: center;
						overflow: hidden;
					}
					.tower-c-cta-bg {
						position: absolute;
						inset: 0;
						background-size: cover;
						background-position: center;
					}
					.tower-c-cta-overlay {
						position: absolute;
						inset: 0;
						background: rgba(243,241,239,0.92);
					}
					.tower-c-cta-title {
						font-size: clamp(1.75rem, 3.5vw, 2.5rem);
						font-weight: 800;
						color: #1a1a1a;
						line-height: 1.3;
						margin-bottom: 2rem;
					}
					/* Structure - white */
					.tower-c-structure {
						padding: 60px 0;
						background: #ffffff;
					}
					.tower-c-structure-badge {
						text-align: center;
						padding: 24px;
						background: rgba(255,255,255,0.9);
						border: 1px solid rgba(0,0,0,0.08);
						border-radius: 16px;
						box-shadow: 0 4px 20px rgba(0,0,0,0.06);
					}
					.tower-c-structure-title {
						font-size: 1.25rem;
						font-weight: 700;
						color: #1a1a1a;
						margin-bottom: 0.5rem;
					}
					.tower-c-structure-sub {
						font-size: 1rem;
						color: #1a1a1a;
						margin: 0;
					}
				`}</style>
			</Fragment>
		);
	}
}

export default GoldcrestDreamTowerC;
